const footerColumns = [
  {
    title: '内容分区',
    links: [
      { label: '娱乐瓜', href: '#fenlei' },
      { label: '网红历史', href: '#fenlei' },
      { label: '明星八卦', href: '#fenlei' },
      { label: '素人爆料', href: '#fenlei' },
    ],
  },
  {
    title: '浏览入口',
    links: [
      { label: '今日快讯流', href: '#kuaixun' },
      { label: '封面热点榜', href: '#remen' },
      { label: '吃瓜互动', href: '#hudong' },
      { label: '投稿通道', href: '#tougao' },
    ],
  },
  {
    title: '投稿形式',
    links: [
      { label: '文字线索', href: '#tougao' },
      { label: '聊天记录', href: '#tougao' },
      { label: '视频素材', href: '#tougao' },
      { label: '现场图片', href: '#tougao' },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-100 border-t border-secondary-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-heading font-bold text-lg">
                黑
              </span>
              <span className="font-heading font-bold text-lg text-foreground-950">黑料投稿</span>
            </div>
            <p className="mt-4 text-sm text-foreground-700 leading-relaxed max-w-md">
              黑料投稿是一个以内容类型分类整理的资讯聚合平台，聚焦娱乐瓜、网红历史、明星八卦与素人爆料。我们欢迎提供真实线索，支持文字、聊天记录、视频素材等多种形式，分类筛选后再整理曝光。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {['每日更新', '分类整理', '快速筛选', '来源可追溯'].map((tag) => (
                <span key={tag} className="px-2.5 py-1 rounded-md bg-background-50 text-xs text-foreground-700 border border-secondary-200">
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-6">
            {footerColumns.map((column) => (
              <div key={column.title}>
                <h3 className="font-heading font-bold text-sm text-foreground-950">{column.title}</h3>
                <ul className="mt-3 space-y-2">
                  {column.links.map((link) => (
                    <li key={`${column.title}-${link.label}`}>
                      <a
                        href={link.href}
                        className="text-sm text-foreground-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600 text-center sm:text-left">
            © 2026 黑料投稿 · 本站内容由网友投稿与编辑整理，仅作信息聚合展示。
          </p>
          <p className="text-xs text-foreground-500 text-center sm:text-right">
            理性吃瓜，尊重隐私 · 请勿提交未经核实的内容
          </p>
        </div>
      </div>
    </footer>
  );
}